export default __webpack_public_path__ + "static/media/get-scholorship1.2192c54b.jpg";